// extracted by mini-css-extract-plugin
export default {"calendar":"cSRDpzSAGV8tiojYhdl6"};